import "./ExpanderStyle.scss";
var ExpanderComponent = /** @class */ (function () {
    function ExpanderComponent(optionsOrHeader, body, expanded) {
        var _a;
        this.State = { expanded: false, waitingForAnimation: false };
        if (body != null) {
            // old syntax
            this.options = { header: optionsOrHeader, body: body, expanded: expanded !== null && expanded !== void 0 ? expanded : true };
        }
        else {
            this.options = optionsOrHeader;
            this.options.expanded = (_a = this.options.expanded) !== null && _a !== void 0 ? _a : true;
        }
        this.State.expanded = this.options.expanded;
    }
    ExpanderComponent.prototype.getIcon = function (expanded) {
        var _a, _b, _c, _d;
        return {
            tag: "span", attr: {
                class: "expand-collapse-icon", style: "padding:0 0.2rem 0 0.2rem;"
            },
            raw: true,
            content: "<svg style='" +
                "min-width:" + ((_a = this.options.iconSize) !== null && _a !== void 0 ? _a : "1.5rem") + "; min-height:" + ((_b = this.options.iconSize) !== null && _b !== void 0 ? _b : "1.5rem") +
                ";max-width:" + ((_c = this.options.iconSize) !== null && _c !== void 0 ? _c : "1.5rem") + "; max-height:" + ((_d = this.options.iconSize) !== null && _d !== void 0 ? _d : "1.5rem") + ";' " +
                "xml:space='preserve' width='1024px' height='1024px' shape-rendering='geometricPrecision' text-rendering='geometricPrecision' image-rendering='optimizeQuality' fill-rule='nonzero' clip-rule='evenodd' viewBox='0 0 10240 10240'>" +
                (expanded
                    ? "<path id='curve0' fill='#FFFFFF' d='M1273 3989l3621 3620c124,125 328,125 452,0l3621 -3620c124,-125 124,-328 0,-453l-905 -905c-125,-125 -328,-125 -453,0l-2489 2489 -2489 -2489c-125,-125 -328,-125 -453,0l-905 905c-124,125 -124,328 0,453z'/>"
                    : "<path id='curve0' fill='#FFFFFF' d='M3989 1273l3620 3621c125,124 125,328 0,452l-3620 3621c-125,124 -328,124 -453,0l-905 -905c-125,-125 -125,-328 0,-453l2489 -2489 -2489 -2489c-125,-125 -125,-328 0,-453l905 -905c125,-124 328,-124 453,0z'/>") +
                "</svg>"
        };
    };
    ExpanderComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    ExpanderComponent.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var animate = this.State.waitingForAnimation;
        this.State.waitingForAnimation = false;
        return {
            tag: "div", attr: { class: "expander-comp " + (this.options.class || ""), style: (_a = this.options.style) !== null && _a !== void 0 ? _a : "" }, children: [
                {
                    tag: "div", attr: {
                        class: "header",
                        click: function (evt) { var _a; if ((_a = _this.options.isToggleOnHeader) !== null && _a !== void 0 ? _a : true) {
                            evt.stopPropagation();
                            _this.toggleExpand();
                        } },
                    },
                    children: [
                        {
                            tag: "span", attr: { class: "toggler", click: function (evt) { evt.stopPropagation(); _this.toggleExpand(); } },
                            children: [this.State.expanded
                                    ? ((_b = this.options.expandedIcon) !== null && _b !== void 0 ? _b : this.getIcon(true))
                                    : ((_c = this.options.collapsedIcon) !== null && _c !== void 0 ? _c : this.getIcon(false))
                            ]
                        },
                        { tag: "span", attr: { class: "content" }, children: [this.toNode(this.options.header)] }
                    ]
                },
                {
                    tag: "div", attr: { class: "body", style: this.State.expanded ? undefined : { display: "none" } },
                    animation: (animate ? { attr: "opacity", from: "0", to: "1", duration: 500 } : undefined),
                    children: [this.toNode(this.options.body)]
                }
            ]
        };
    };
    ExpanderComponent.prototype.toggleExpand = function () {
        var newVal = !this.State.expanded;
        if (this.options.onToggle != null) {
            if (this.options.onToggle(newVal) === false) {
                return;
            }
        }
        if (newVal) {
            this.State.waitingForAnimation = true;
        }
        this.State.expanded = newVal;
    };
    ExpanderComponent.prototype.toNode = function (content) {
        if (typeof content === "string") {
            return { tag: "div", content: content };
        }
        return content;
    };
    return ExpanderComponent;
}());
export { ExpanderComponent };
